import PropTypes from "prop-types";
import { Box } from "@mui/material";
import LabCatalogAuthBridge from "app/views/lab-catalog/LabCatalogAuthBridge";
import "lab-catalog-shell/styles/lab-catalog.css";

/**
 * Auth bridge for Radiology shell pages.
 * Page chrome (breadcrumbs/cards) comes from RadiologyC1Page / C1ListPanel.
 * lab-catalog.css retained only for residual shared token utilities still referenced by form widgets.
 */
export default function RadiologyShellLayout({ children }) {
  return (
    <LabCatalogAuthBridge>
      <Box data-testid="radiology-shell-root" sx={{ minHeight: "100%" }}>
        {children}
      </Box>
    </LabCatalogAuthBridge>
  );
}

RadiologyShellLayout.propTypes = {
  children: PropTypes.node,
};
